module.exports = __webpack_public_path__ + "img/14logo.473148fd.svg";